// NIKAO CUP -- roll of honour.
//
// Newest first. To add next season's champion, add an entry at the top:
//
//   {
//     year: 2026,
//     name: 'Someone',
//     division: 'Woods',            // optional
//     photo: '/winner-2026-someone.webp',   // optional, put the file in public/
//     photoAlt: '...',              // optional
//     note: 'Anything worth remembering',   // optional
//   }
//
// `name` is the spelling as engraved on the trophy -- Harvey Mosley's 2025
// plate reads "Harvey Mosley", so that is what the site shows.

export const PAST_WINNERS = [
  {
    year: 2025,
    name: 'Harvey Mosley',
    photo: '/winner-2025-harvey-mosley.webp',
    photoAlt: 'Harvey Mosley holding the 2025 NIKAO Cup',
    inscription: 'The "NIKAO CUP" — 2025 Match Play Champion',
  },
];

export const CURRENT_CHAMPION = PAST_WINNERS[0] || null;
